export default "__VITE_ASSET__CDLj9Iwt__"